/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-18 17:44:35
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-01 17:23:53
 * @FilePath: /unifyxp-v2-store-portal/src/components/Card/ContentCard/index.tsx
 */
import React from 'react';

import css from './css.less';

import { InfoCircleFilled } from '@ant-design/icons';
import GlobalTooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import Dot from 'src/constrains/DotsMenuDrop';

const ContentCard = (props) => {
  const {
    titleColor,
    err,
    title,
    // onClick,
    dotsFunctions = [],
    content,
    hideDots,
  } = props;
  return (
    <div className={css.wrapper}>
      <div className={css.container}>
        <div className={css.contentContainer}>
          <div className={css.textContainer}>
            <div
              className={css.timeText}
              {...(titleColor ? { style: { color: titleColor } } : {})}>
              <NoWrapContainer>
                <GlobalTooltip title={title}>{title}</GlobalTooltip>
              </NoWrapContainer>
            </div>
          </div>
          <div className={css.textContainer}>
            <div className={css.contentText}>
              <NoWrapContainer>
                <GlobalTooltip title={content}>{content}</GlobalTooltip>
              </NoWrapContainer>
            </div>
          </div>
        </div>
        {err && (
          <div
            className={`${css.errorContainer} ${
              hideDots ? css.dotsHided : ''
            }`}>
            <InfoCircleFilled className={css.error} />
          </div>
        )}
        {!hideDots && (
          <div className={css.moreActionContainer}>
            <Dot options={dotsFunctions} />
          </div>
        )}
      </div>
    </div>
  );
};

export default ContentCard;
